var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrizzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "drizzle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0072F5",
    d: "M11.5342,20.0402c-0.064,0-0.129-0.012-0.192-0.0381 c-0.255-0.1059-0.376-0.399-0.27-0.6529l0.478-1.155c0.106-0.2561,0.401-0.375,0.654-0.2711c0.255,0.1061,0.376,0.399,0.27,0.654 l-0.478,1.1541C11.9162,19.9241,11.7302,20.0402,11.5342,20.0402 M8.2602,19.7312l0.478-1.1541 c0.106-0.255-0.015-0.5479-0.27-0.654c-0.253-0.1039-0.547,0.015-0.653,0.2711l-0.479,1.155 c-0.105,0.2539,0.016,0.5471,0.271,0.6529c0.062,0.0261,0.127,0.0381,0.191,0.0381C7.9942,20.0402,8.1802,19.9241,8.2602,19.7312  M15.7322,19.7312l0.478-1.1541c0.106-0.255-0.016-0.5479-0.27-0.654c-0.253-0.1039-0.548,0.015-0.654,0.2711l-0.478,1.155 c-0.106,0.2539,0.015,0.5471,0.27,0.6529c0.063,0.0261,0.128,0.0381,0.192,0.0381C15.4652,20.0402,15.6522,19.9241,15.7322,19.7312 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M5.25,15.5c-1.5166,0-2.75-1.2334-2.75-2.75 c0-1.1265,0.6777-2.127,1.7266-2.5483l0.3506-0.1406l-0.04-0.3755C4.5137,9.4609,4.5,9.2324,4.5,9c0-3.584,2.916-6.5,6.5-6.5 c2.9912,0,5.583,2.0288,6.3018,4.9331l0.0908,0.3677l0.3789,0.0117C19.8623,7.8789,21.5,9.5645,21.5,11.6499 c0,2.123-1.7275,3.8501-3.8506,3.8501H5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D33",
    d: "M10.9999,3c2.761,0,5.1527,1.8723,5.8163,4.5532l0.182,0.7352l0.757,0.024 c1.8195,0.0576,3.2447,1.5237,3.2447,3.3375c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2407,0-2.25-1.0094-2.25-2.25 c0-0.921,0.5546-1.739,1.413-2.0841l0.6992-0.2811L5.0346,9.6353C5.0113,9.4094,4.9999,9.2015,4.9999,9 C4.9999,5.6917,7.6915,3,10.9999,3 M10.9999,2c-3.866,0-7,3.1329-7,7c0,0.25,0.015,0.4961,0.04,0.738 c-1.194,0.48-2.04,1.645-2.04,3.012c0,1.7939,1.455,3.25,3.25,3.25h12.4c2.403,0,4.35-1.948,4.35-4.35 c0-2.3561-1.875-4.2629-4.213-4.337C17.0319,4.2629,14.2839,2,10.9999,2L10.9999,2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrizzle);
export default __webpack_public_path__ + "static/media/drizzle.9115cb327c5b6d2641bb2260d351d832.svg";
export { ForwardRef as ReactComponent };